import { render, staticRenderFns } from "./nutritiousDiningProcurement.vue?vue&type=template&id=c9ba7202&scoped=true&"
import script from "./nutritiousDiningProcurement.vue?vue&type=script&lang=js&"
export * from "./nutritiousDiningProcurement.vue?vue&type=script&lang=js&"
import style0 from "./nutritiousDiningProcurement.vue?vue&type=style&index=0&id=c9ba7202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ba7202",
  null
  
)

export default component.exports